import { duplicateCheckMarketCooperation } from '@/api/common'
import commonData from "@/utils/commonData";

/* 联系方式验证 */
export const checkContactMode = function (rule: any, value: string, callBack: Function) {
    if (value === '') {
        callBack(new Error('联系方式不能为空'))
    }
    const reg = /^[^\u4e00-\u9fa5]+$/
    if (!reg.test(value)) {
        callBack(new Error('联系方式不能包含中文'))
    } else {
        callBack()
    }

}

/* 合作伙伴查重和验证 */
export const checkPartnerName = async function (rule: any, value: string, callBack: Function) {
    if (value) {
        const data: any = await duplicateCheckMarketCooperation(value)
        if (data.marketCooperation.length === 0) {
            callBack()
        } else {
            callBack(new Error('合作方名称已存在'))
        }
    } else {
        callBack(new Error('合作方名称不能为空'))
    }
}

/**
 * @desc 将每一个返佣范围转化成可比较的对象
 * @param {Object} obj 每一个返佣范围
 * @returns {Object} 返回一个转化后的对象
 * **/
 const conversionRatioItem = function (obj, index: number) {
    const newObj: { min: number; max: number; index: number } = { min: undefined, max: undefined, index }
    if (obj.endCondition && Number(obj.endNum)) {
        if (obj.startCondition.includes('大于')) {
            newObj.min = obj.startCondition === '大于' ? Number(obj.startNum) + 0.001 : Number(obj.startNum)
            newObj.max = obj.endCondition === '小于' ? Number(obj.endNum) - 0.001 : Number(obj.endNum)
        }
        if (obj.startCondition.includes('小于')) {
            newObj.max = obj.startCondition === '小于' ? Number(obj.startNum) - 0.001 : Number(obj.startNum)
            newObj.min = obj.endCondition === '大于' ? Number(obj.endNum) + 0.001 : Number(obj.endNum)
        }
    } else {
        if (obj.startCondition.includes('大于')) {
            newObj.min = obj.startCondition === '大于' ? Number(obj.startNum) + 0.001 : Number(obj.startNum)
            newObj.max = Infinity
        }
        if (obj.startCondition.includes('小于')) {
            newObj.max = obj.startCondition === '小于' ? Number(obj.startNum) - 0.001 : Number(obj.startNum)
            newObj.min = 0
        }
        if (obj.startCondition === '等于') {
            newObj.max = Number(obj.startNum) + 0.001
            newObj.min = Number(obj.startNum) - 0.001
        }
    }
    return newObj
}

// 阶梯返佣范围内部错误判定
export const ladderItemError = function (data): boolean[] {
    return data.map((item, index) => {
        const obj = conversionRatioItem(item, index)
        return obj.min < obj.max
    })
}

/* 阶梯返佣范围之间冲突验证 */
export const ladderRatioCheck = function (data) {
    const arr = data
        .map((item, index) => conversionRatioItem(item, index))
        .sort((a, b) => { return a.min - b.min })
    const newobj = arr.map((item, index) => {
        const obj = { bol: false, index1: undefined, index2: undefined }
        if (index > 0) {
            if (item.min > arr[index - 1].max === false) {
                obj.bol = true
                obj.index1 = index
                obj.index2 = index - 1
            }
        }
        return obj
    })
    return newobj
}

// 项目类型列表
export const souCoueTypeList = commonData.projectTypeArray

// 表单验证
export const formRules = {
    // name: [{ required: true, validator: checkPartnerName }],
    name: [{ required: true, message: '合作方名称不能为空', trigger: 'blur' }],
    source: [{ required: true, message: '来源不能为空', trigger: 'change' }],
    types: [{ required: true, message: '合作伙伴类型不能为空', trigger: 'change' }],
    contact: [{ required: true, message: '机构联系人不能为空', trigger: 'blur' }],
    contactInfo: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],
    contractType: [{ required: true, message: '请选择合同类型', trigger: 'change' }],
    signAt: [{ required: true, message: '请选择机构签约时间', trigger: 'change' }],
    city: [{required: true, message: '请选择机构所在城市', trigger: ['change', 'blur']}],
    // invoiceType: [{ required: true, message: '请选择开票类型', trigger: 'change' }],
    // invoiceTitle: [{ required: true, message: '开票抬头不能为空', trigger: 'blur' }],
    // invoiceCode: [{ required: true, message: '纳税识别号不能为空', trigger: 'blur' }],
    // invoiceBank: [{ required: true, message: '开票行不能为空', trigger: 'blur' }],
    // invoiceAccount: [{ required: true, message: '开票账号不能为空', trigger: 'blur' }],
    // invoiceAddress: [{ required: true, message: '开票地址不能为空', trigger: 'blur' }],
    // invoicePhone: [{ required: true, message: '电话不能为空', trigger: 'blur' }],
    backMoneyType: [{required: true, message: '回款类型不能为空', trigger: ['change', 'blur']}],
    signType: [{required: true, message: '客户签署类型不能为空', trigger: ['change', 'blur']}],
}
